import { LabeledControl } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledLabeledControl = styled(LabeledControl)`
  display: flex;
  align-items: center;
`;
